import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorIntlPt } from "../../shared/mat-paginator-intl-pt"
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common';
import { EmitirRelatoriosComponent } from './emitir-relatorios.component';
import { RelatoriosService } from './relatorios.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatMenuModule } from '@angular/material/menu';
import { CpfCnpjCacealMaskDirective } from 'app/directives/cpf-cnpj-caceal-mask.directive';
import { CnpjCacealMaskDirective } from 'app/directives/cnpj-caceal-mask.directive';
import { RelatorioEntregasArquivosComponent } from './relatorio-entregas-arquivos/relatorio-entregas-arquivos.component';
import { RouterModule } from '@angular/router';


@NgModule({
    declarations: [
        EmitirRelatoriosComponent,
        CpfCnpjCacealMaskDirective,
        CnpjCacealMaskDirective,
        RelatorioEntregasArquivosComponent
    ],
    imports: [
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        NgxSpinnerModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatRadioModule,
        MatIconModule,
        MatTooltipModule,
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        NgxMaskPipe,
        MatMenuModule,
        RouterModule
    ],
    providers: [
        RelatoriosService, { provide: MatPaginatorIntl, useClass: MatPaginatorIntlPt }, provideNgxMask()
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConsultaOmissaoModule {}
